<template>
    <div id="cardDetails">
        <div class="section1">        
            <el-form :inline="true" ref="cardDetailsForm" @submit.native.prevent :model="cardDetailsForm" :rules="cardDetailsRules">
                <el-form-item prop="iccid">
                    <el-input v-model.trim="cardDetailsForm.iccid"  @keyup.enter.native="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)"  placeholder="请输入ICCID号或接入号" v-focus clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)">搜索</el-button>
                </el-form-item>
            </el-form>             
        </div>
        <template v-if="showDetail">
            <div class="section2">
                <h4>基本信息</h4>
                <el-row>
                    <el-col :span="6">
                        <img v-show="cardInfo.supplierTypeCode == 3" style="width:120px" src="./../../assets/img_yidong.png" alt="">
                        <img v-show="cardInfo.supplierTypeCode == 4" style="width:120px" src="./../../assets/img_liantong.png" alt="">
                        <img v-show="cardInfo.supplierTypeCode == 1 || cardInfo.supplierTypeCode == 5" style="width:120px" src="./../../assets/img_dianxin.png" alt="">
                    </el-col>
                    <el-col :span="18">
                        <el-row>
                            <el-col :span="8">ICCID号： 
                                <el-tooltip effect="dark" content="点击查看流量轮询详情" placement="top">
                                    <a href="javascript:void(0);" @click="toFluxPollDetail(cardInfo.iccid)">{{ cardInfo.iccid }}</a>
                                </el-tooltip>
                            </el-col>
                             <el-col :span="8" v-if="cardInfo.supplierName&&cardInfo.supplierName.indexOf('运城')==0&& cardInfo.cardState == 11"> 
                                <span style="font-size: 28px; color: red;" > 供应商： {{ cardInfo.supplierName }}</span>
                            </el-col>
                            <el-col :span="8" v-else>供应商： {{ cardInfo.supplierName }}</el-col>
                            <el-col :span="8">通道： {{ cardInfo.alias }}</el-col>                      
                        </el-row>
                        <el-row>
                            <el-col :span="8">接入号： {{ cardInfo.intoNo }}</el-col>
                            <el-col :span="8">卡类型： {{ cardInfo.cardTypeName }}</el-col>
                            <el-col :span="8">套餐组： {{ cardInfo.basePkgGroupName }}</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">流量池子： {{ cardInfo.flowRatePool }}</el-col>
                            <el-col :span="8">      
                                <el-col :span="24" v-if="cardInfo.supplierName&&cardInfo.supplierName.indexOf('运城')==0 && cardInfo.cardState == 11"> 
                                    <span style="font-size: 28px; font-weight:blod; color: red;" > 卡状态：{{ cardInfo.cardStateName }}</span>
                                </el-col>

                                <el-col :span="12" v-else>卡状态： 
                                    <span class="font-defined dark" v-if="cardInfo.cardState == 1"> {{ cardInfo.cardStateName }}</span>
                                    <span class="font-defined green" v-else-if="cardInfo.cardState == 2">{{ cardInfo.cardStateName }}</span>
                                    <span class="font-defined red" v-else-if="cardInfo.cardState == 4"> {{ cardInfo.cardStateName }}</span>
                                    <span class="font-defined" v-else> {{ cardInfo.cardStateName }}</span>
                                </el-col>  

                            </el-col>

                            <el-col :span="8" v-if="cardInfo.flowRatePercent!=null">
                            可使用流量比： <span class="font-defined" >{{ cardInfo.flowRatePercent }} %</span>
                            </el-col>

                        </el-row>


                        <el-row>
                            <el-col :span="16" v-if="cardInfo.supplierName&&cardInfo.supplierName.indexOf('运城')==0 && cardInfo.cardState == 11">
                                <span style="display:inline-block; color: red; font-size: 24px; transform: translateY(100px);" class="text-animation-default">变更卡状态备注： {{ cardInfo.changeStateRemark }}</span>
                            </el-col> 
                            <el-col :span="16" v-else>变更卡状态备注： {{ cardInfo.changeStateRemark }}</el-col>

                            <el-col :span="8">
                                <el-button type="primary" size="mini" @click="updateStateHandler(cardInfo.iccid, true)">更新</el-button>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
            </div>
            <div class="section3">
                <h4>套餐信息</h4>
                <div>
                    <div v-for="item in cardInfo.simPackageList" :key="item.id" style="margin-bottom:40px;">
                        <h5><span class="span-defined">订单号：{{ item.id }}</span>套餐名称：{{ item.packageName }}</h5>
                        <el-row>
                            <el-col :span="7" class="progressOuter">
                                <el-progress :stroke-width="8" :percentage="item.usedFlowRate/item.flowRate *100" :show-text="false"></el-progress>
                                <div>
                                    <div class="fr">剩余：{{ decrease(fluxMtoG(item.flowRate) , fluxMtoG(item.usedFlowRate)) }}G</div>
                                    <div>已用：{{ fluxMtoG(item.usedFlowRate) }}G / {{ fluxMtoG(item.flowRate) }}G</div>                            
                                </div>
                            </el-col>
                            <el-col :span="6"  style="text-align: center;">
                                <p v-if="item.state==4" class="progressOuter pOuter" style="color: red;">退款中</p>
                                <p v-else-if="item.state==3" class="progressOuter pOuter" style="color: red;">已退款</p>
                                已用（真）：{{ fluxMtoG(item.usedRealFlowRate) }}G
                            </el-col>                    
                            <el-col :span="4">流量百分比：{{ item.flowRatePercent }}%</el-col>

                            <el-col :span="5" >
                                <p class="progressOuter pOuter" >生效时间：{{ item.startTime }}</p>
                                <p v-if="isExpiredTime(item.endTime)" style="color: red;">过期时间：{{ item.endTime }}</p>
                                <p v-else >过期时间：{{ item.endTime }}</p>
                            </el-col>
                            
                            <el-col :span="2">
                                <el-button @click="showChangePkgEndTimeHandler(item)">修改过期时间</el-button>
                            </el-col>
                             <el-col :span="2">
                                <el-button @click="showChangePkgEndTimeHandler1(item)">修改套餐流量</el-button>
                            </el-col>
                        </el-row>
                    </div> 

                    <div  style="margin-top: -30px; font-size: 16px; font-weight: 600;" v-show="getSum > 0">
                        <el-row>
                            <el-col :span="7" >&nbsp;</el-col>
                            <el-col :span="8" style="text-align: center;">本月已用流量：{{cardInfo.monthTotal?fluxMtoG(cardInfo.monthTotal):0}} G ；&nbsp;总计已用流量：{{getSum}} G</el-col>                    
                        </el-row>
                    </div>


                </div>
            </div>
            <div class="section4">
                <h4>操作管理</h4>
                <div>
                    <el-button size="normal" @click="showAddPkg">添加套餐</el-button>
                    <el-button size="normal" @click="stopSimHandler">保号停机</el-button> 
                    <el-button size="normal" @click="resetSimHandler">保号复机</el-button>
                       <el-button size="normal" @click="resetSimHandler1" plain icon="el-icon-s-ticket">机卡分离复机</el-button>
                    <el-button size="normal" @click="showToNewCardHandler">转新卡</el-button>
                    <el-button size="normal" @click="simDiagnosisHandler">一键诊断</el-button>
                    <el-button size="normal" @click="stateRecordListHandler">停复机记录</el-button>
                    <el-button size="normal" @click="getFluxDetailListHandler">流量使用情况 </el-button>
                    <el-button size="normal" @click="showChangePkgGoupHandler">变更套餐组 </el-button>
                    <el-button size="normal" @click="showChangeCardStateHandler">变更卡状态 </el-button>
                    <el-button size="normal" @click="showAddOverlayPkg">添加叠加包 </el-button>
                    <el-button size="normal" @click="showAddRealNameSearch">实名查询 </el-button>
                     <el-button size="normal" @click="resetFlow1">机卡解绑 </el-button>
                    <el-button size="normal" @click="resetFlow">重置流量</el-button>
                </div>
            </div>
            <div class="section5">
                <h4>往期订单</h4>
                <el-table :data="tableData" border>
                    <el-table-column prop="orderNo" width="240" label="订单号"></el-table-column> 
                    <el-table-column prop="packageName" width="120" label="套餐名称"></el-table-column> 
                    <el-table-column prop="packageTypeName" width="120"  label="套餐类型"></el-table-column> 
                    <el-table-column label="套餐流量" width="120" >
                        <template slot-scope="scope">
                            <span>{{ fluxMtoG(scope.row.flowRate) }}G</span>
                        </template>
                    </el-table-column> 
                    <el-table-column prop="createTime" width="160"  label="订购时间"></el-table-column> 
                    <el-table-column prop="createTypeName" width="120"  label="订购类型"></el-table-column> 
                    <el-table-column prop="isNextMonthName" width="120"  label="生效时间"></el-table-column> 
                    <el-table-column label="备注">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" clearable @blur="modifyOrderInfoHandler(scope.row)"></el-input>
                            <!-- <a href="javascript:void(0)" @click="showOrderDetailHandler(scope.row)">{{scope.row.remark}}</a>     -->
                        </template>    
                    </el-table-column> 
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination> 
            </div>
        </template>

        <el-dialog :append-to-body="true"  title="修改过期时间" :visible.sync="endTimeVisible" width="600px" @close="endTimecancel" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
                <el-form-item label="修改方式：" prop="type">
                    <el-select v-model="endTimeForm.type">
                        <el-option value="1" label="指定过期时间">指定过期时间</el-option>
                        <el-option value="2" label="指定延长天数"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原过期时间：">
                    <div>{{ endTimeForm.oldTimeString }}</div>
                </el-form-item>
                <el-form-item v-if="endTimeForm.type == 1" label="新过期时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newTimeString" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>                
                <el-form-item v-else label="延长天数：" prop="dayNum">
                    <el-input v-model="endTimeForm.dayNum" placeholder="请输入天数" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="endTimeForm.remark"  clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler">确 定</el-button>
            </div> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="修改套餐流量" :visible.sync="endTimeVisible1" width="600px" @close="endTimecancel" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
                
                <el-form-item label="已使用流量/M：" prop="useData">
                    <el-input type="textarea" v-model="endTimeForm.useData"  clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler1">确 定</el-button>
            </div> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="新增套餐" :visible.sync="addPkgVisible" width="600px" @close="addPkgCancel" :close-on-click-modal="false">
            <el-form ref="addPkgForm" :model="addPkgForm" :rules="addPkgRules" label-width="130px">
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-radio-group v-model="addPkgForm.packageId" class="pkgName" 
                    @change="changeAddPkgFormItem">
                        <el-radio v-for="item in pkgList" :key="item.id" :label="item.id" style="padding: 10px 0;"> 
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth" v-if="addPkgFormIsNextMonth">
                    <el-select v-model="addPkgForm.isNextMonth" >
                        <el-option value="0" label="本月生效">本月生效</el-option>
                        <el-option value="1" label="次月生效">次月生效</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="购买上游套餐：" prop="toBuy">
                    <el-radio-group v-model="addPkgForm.toBuy">
                        <el-radio :label="2">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>          
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="addPkgForm.remark" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddPkgHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog :append-to-body="true"  title="转新卡" :visible.sync="toNewCardVisible" width="600px" @close="toNewCardCancel" :close-on-click-modal="false">
            <el-form ref="toNewCardForm" :model="toNewCardForm" :rules="toNewCardRules" label-width="120px">
                <el-form-item label="新卡ICCID号：" prop="iccid">
                    <el-input v-model.trim="toNewCardForm.iccid" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="moveType">
                    <el-radio-group v-model="toNewCardForm.moveType">
                        <el-radio label="1">全部</el-radio>
                        <el-radio label="2">仅转流量</el-radio>
                        <el-radio label="3">仅转层级</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="toNewCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="toNewCardCancel">取 消</el-button>
                <el-button type="primary" @click="sureToNewCardHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true"  title="停复机记录" :visible.sync="stateRecordVisible" width="80%" :close-on-click-modal="false">
            <el-table :data="tableData_record" border  height="421">
                <el-table-column prop="stateName" label="操作类型"></el-table-column> 
                <el-table-column prop="createTypeName" label="操作来源"></el-table-column>
                <el-table-column prop="createTime" label="操作时间"></el-table-column> 
                <el-table-column prop="createOptName" label="操作人"></el-table-column>
                <el-table-column prop="failReason" label="失败原因"></el-table-column>   
            </el-table>
            <el-pagination
                @size-change="handleSizeChangeRecord"
                @current-change="handleCurrentChangeRecord"
                :current-page="currentPage_record"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="pageSize_record"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total_record">
            </el-pagination>              
        </el-dialog> 
        <el-dialog :append-to-body="true"  title="流量使用详情" :visible.sync="fluxVisible" width="80%" :close-on-click-modal="false">
            <el-table :data="tableData_flux" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column label="本月已用流量（G）">
                    <template slot-scope="scope">
                        <span>{{ fluxMtoG(scope.row.monthTotal) }}</span>
                    </template>
                </el-table-column> 
                <el-table-column prop="createTime" label="查询时间 "></el-table-column> 
            </el-table>
            <el-pagination
                @size-change="handleSizeChangeFlux"
                @current-change="handleCurrentChangeFlux"
                :current-page="currentPage_flux"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="pageSize_flux"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total_flux">
            </el-pagination>             
        </el-dialog> 
        <el-dialog :append-to-body="true"  title="变更套餐组" :visible.sync="changePkgGroupVisible" width="600px"  @close="changePkgGroupCancel" :close-on-click-modal="false">
            <el-form ref="pkgGroupForm" :model="pkgGroupForm" label-width="120px">
                <el-form-item label="原套餐组名称：">
                    <span>{{ cardInfo.basePkgGroupName }}</span>
                </el-form-item>
                <el-form-item label="新套餐组名称：" prop="newPkgGroup">
                    <el-select v-model="pkgGroupForm.newPkgGroup" filterable>
                        <el-option v-for="item in allowPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="pkgGroupForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changePkgGroupCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgGroupHandler">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog :append-to-body="true"  title="变更卡状态" :visible.sync="changeStateVisible" width="600px" @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm" :rules="changeStateRules" label-width="100px">

                <el-form-item label="类型：" prop="state">
                    <el-select v-model="changeStateForm.state" clearable>
                        <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="'转'+item.description"></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="changeStateForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler">确 定</el-button>
            </div> 
        </el-dialog>

        <!-- 订单详情 -->
        <el-dialog :append-to-body="true"  title="订单详情" :visible.sync="orderDetailVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{orderDetailForm.orderNo}}</span>
            </div>
 
            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{orderDetailForm.packageName}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{orderDetailForm.priceRmb}} 元</span>
            </div>
 
            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{orderDetailForm.createTime}}</span>
            </div>

            <div class="lineInDialog">
                <label>备注：</label>
                <div v-html="orderDetailForm.remark">
                </div>
                
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>            
        </el-dialog>

        <el-dialog :append-to-body="true"  title="添加叠加包" :visible.sync="overlayPkgVisible" width="600px" @close="overlayPkgCancel" :close-on-click-modal="false">
            <el-form ref="overlayPkgForm" :model="overlayPkgForm" :rules="overlayPkgRules" label-width="100px">
                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="overlayPkgForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in overlayPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="overlayPkgForm.packageId" clearable>
                        <el-option v-for="item in overlayPkgList" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="overlayPkgForm.isNextMonth" clearable>
                        <el-option value=0 label="本月生效"></el-option>
                        <el-option value=1 label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="overlayPkgForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="overlayPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddOverlayPkg">确 定</el-button>
            </div> 
        </el-dialog>
    </div>
</template>

<script>
import {getSimDetailInfo, getOneSIMOrderList, addPkg, getPkgList, getAllowChangePkgGroup, toChangePkgGroup, changePkgEndTime, delayPkgEndTime, toNewCard, simDiagnosis, updateState, stopSim, resetSim, getFluxDetailList, getSimStopStartRecordList, changeCardState, getOverlayPkgOptions, getRealName} from '@/api/sim.js'
import {modifyOrderRemark} from '@/api/order.js'
import common from '@/utils/common.js'

import '@/styles/txt.wav.css'

export default {
    data(){
        return {
            cardDetailsForm: {
                iccid: ''
            },
            showDetail: false,
            cardInfo: {
                id: '',
                supplierTypeCode: '',
                iccid: '',
                supplierName: '',
                alias: '',
                cardTypeName: '',
                endTime: '',
                intoNo: '',
                cardState:'',
                flowRatePool: '',
                basePkgGroupName: '',
                cardStateName: '',
                flowRatePercent:null,
                simPackageList: [],
                monthTotal:null,
                changeStateRemark: "",
            },
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            addPkgVisible: false,       //添加套餐
            pkgList: [],
            addPkgForm: {
                isNextMonth: '0',
                packageId: '',
                toBuy: 1,
                remark: ''
            },
            addPkgFormIsNextMonth:false,
            toNewCardVisible: false,    //转新卡
            toNewCardForm: {
                iccid: '',
                moveType: '1',
                remark: ''
            },
            stateRecordVisible: false,  //停复机记录
            'tableData_record': [],
            'currentPage_record': 1,
            'pageSize_record': 10,
            'total_record': 0,
            fluxVisible: false,         //流量使用详情
            'tableData_flux': [],
            'currentPage_flux': 1,
            'pageSize_flux': 10,
            'total_flux': 0,
            endTimeVisible: false,     //修改过期时间
            endTimeVisible1: false,     //修改过期时间
            endTimeForm: {          
                type: '1',
                pkgId: '',
                oldTimeString: '',
                newTimeString: '',
                dayNum: 0,
                remark: '',
                useData:'',
                id:''
            },
            changePkgGroupVisible: false, //变更套餐组
            allowPkgGroup: [],
            pkgGroupForm: {
                newPkgGroup: '',
                remark: ''
            },
            changeStateVisible: false,    //变更卡状态
            cardStateOption:[],
            changeStateForm: {
                state: '',
                remark: ''
            },
            overlayPkgVisible: false,
            overlayPkgForm: {
                typeGroupId: '',
                packageId: '',
                isNextMonth: '',
                remark: ''
            },
            overlayPkgGroup: [],
            overlayPkgList: [],
            cardDetailsRules: {
                iccid: [{required: true, message: '请输入ICCID号或接入号', trigger: 'blur'}]
            },
            addPkgRules: {
                packageId: [{required: true, message: '请选择要充值的套餐', trigger: 'blur'}],
                toBuy: [{required: true, message: '请选择', trigger: 'change'}]
            },
            toNewCardRules:{
                iccid: [{required: true, validator: this.checkIccid, trigger: 'change'}]
            },
            changeStateRules: {
                state: [{required: true, message: '请选择变更状态', trigger: 'blur'}],
                remark: [{required: true, message: '请选择输入变更原因', trigger: 'blur'}],
            },
            overlayPkgRules: {
                
            },
            orderDetailVisible:false,
            orderDetailForm: {},
        }
    },
    // 指令
    directives: {
        focus: {
            inserted: function (el) {
                function getFocus(element){
                    if(element.nodeName === 'INPUT'){
                        element.focus();
                        return;
                    }else if(element.children.length > 0){
                        for(let i=0; i<element.children.length; i++){
                            getFocus(element.children[i])
                            return;
                        }
                    }
                }
                getFocus(el);
            }
        }
    },
    methods: {
        resetSimHandler1(){
             var data = {
                    iccid: this.cardInfo.iccid
                }
             common.sysRequest('sim/activity/noBind',data, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                   this.getSimDetailInfoHandler(this.cardInfo.iccid);
                }else{
                    this.$message.error(res.data.message);
                }
            })
                
        },
        
        addPkgCancel(){
            this.addPkgVisible = false;
            this.$refs.addPkgForm.resetFields();
        },
        endTimecancel(){
            this.endTimeVisible = false;
            this.endTimeVisible1 = false;
            this.$refs.endTimeForm.resetFields();
        },
        toNewCardCancel(){
            this.toNewCardVisible = false;
            this.$refs.toNewCardForm.resetFields();
        },
        changePkgGroupCancel(){
            this.changePkgGroupVisible = false;
            this.$refs.pkgGroupForm.resetFields();
        },
        changeStateCancel(){
            this.changeStateVisible = false;
            this.$refs.changeStateForm.resetFields();
        },
        overlayPkgCancel(){
            this.overlayPkgVisible = false;
            this.$refs.overlayPkgForm.resetFields();            
        },
        getSimDetailInfoHandler(iccid, $event){
            if($event){
                Object.assign(this.$data, this.$options.data());  //重置为初始值
                this.cardDetailsForm.iccid = iccid
            }
            this.$refs.cardDetailsForm.validate( valid => {
                if(valid){                   
                    var data = {
                        iccid
                    }
                    getSimDetailInfo(data).then(res => {
                        if(res.data.code == 200){
                            this.showDetail = true;
                            var result = res.data;
                            for(var key in this.cardInfo){
                                this.cardInfo[key] = res.data.data[key];
                            }
                            this.$nextTick(() => {
                                this.updateStateHandler(iccid, false);
                                this.showDetail = true;
                            })
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                    this.getOneSIMOrderListHandler(); 
                }
            })
        },
        getOneSIMOrderListHandler(){
            var data = {
                perPageNum: this.pageSize,
                pageNo: this.currentPage,                
                iccid: this.cardDetailsForm.iccid
            }
            getOneSIMOrderList(data).then(res => {  //获取往期来往订单
                if(res.data.code == 200){
                    var result = res.data.data;
                    this.tableData = result.resultList;
                    this.total = result.totalNum;
                    this.currentPage = result.pageNo;
                    this.pageSize = result.perPageNum;                     
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        changeAddPkgFormItem(value){
            for(let i=0; i<this.pkgList.length; i++){
                if(value==this.pkgList[i].id){
                    this.addPkgFormIsNextMonth = this.pkgList[i].type == 2||this.pkgList[i].type == 10||this.pkgList[i].type == 14||this.pkgList[i].type == 19;
                }
            }
        },
        updateStateHandler(iccid, showSuccessMsg){
            var data = { iccid };
            updateState(data).then(res => {
                if(res.data.code == 200){
                    if(showSuccessMsg){
                        this.$message.success(res.data.message);
                    }
                    getSimDetailInfo(data).then(res => {
                        if(res.data.code == 200){
                            this.showDetail = true;
                            var result = res.data;
                            for(var key in this.cardInfo){
                                this.cardInfo[key] = res.data.data[key];
                            }
                        }
                    });
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },        
        showChangePkgEndTimeHandler(item){
            this.endTimeVisible = true;
            this.endTimeForm.oldTimeString = item.endTime;
            this.endTimeForm.pkgId = item.id;
        },
        showChangePkgEndTimeHandler1(item){
            this.endTimeVisible1 = true;
            this.endTimeForm.useData = item.usedFlowRate;
            this.endTimeForm.pkgId = item.id;
        },
        sureChangePkgEndTimeHandler1(){
             var data = {
                    id: this.endTimeForm.pkgId,
                    useData: this.endTimeForm.useData
                }
             common.sysRequest('external/update/pkg/data', data, 'post').then(res => {
                if(res.data.code == 200){
                      this.endTimeVisible1 = false;
                        this.$message.success('修改完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        sureChangePkgEndTimeHandler(){
            if(this.endTimeForm.type == 1){
                var data = {
                    simPkgId: this.endTimeForm.pkgId,
                    newTimeString: this.endTimeForm.newTimeString,
                    remark: this.endTimeForm.remark            
                }
                changePkgEndTime(data).then(res => {
                    if(res.data.code == 200){
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else if(res.data.code == 400){
                        this.$message.error(res.data.message);
                    }
                })            
            }else{
                var dataP = {
                    simPkgId: this.endTimeForm.pkgId,
                    dayNum: this.endTimeForm.dayNum,
                    remark: this.endTimeForm.remark   
                }
                delayPkgEndTime(dataP).then(res => {
                    if(res.data.code == 200){
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else if(res.data.code == 400){
                        this.$message.error(res.data.message);
                    }
                })                
            }
        },
        showAddPkg(){            
            var data = {
                iccid: this.cardInfo.iccid
            }            
            getPkgList(data).then(res => {
                var result = res.data.data;
                if(res.data.code == 200){
                    if(result.length > 0){
                        this.addPkgVisible = true;
                        this.pkgList = result;
                    }else{
                        this.$message.error('该套餐组下无可添加的套餐！')
                    }
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        sureAddPkgHandle(){
            this.$refs.addPkgForm.validate(valid => {
                if(valid){
                    var data = this.addPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.addPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })                    
                }
            })
        },
        stopSimHandler(){
            this.$confirm("您确定要进行停机操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                stopSim(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("停机完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        if(res.data){
                            this.$message.error(res.data.message);
                        }
                    }                    
                })
            })
        },
        resetSimHandler(){
            this.$confirm("您确定要进行复机操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                resetSim(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("复机完成！")
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        this.$message.error(res.data.message)
                    }                    
                })
            })
        },
        showChangePkgGoupHandler(){
            this.changePkgGroupVisible = true;            
            var data = {
                basePkgGroup: this.cardInfo.basePkgGroup,
                iccid: this.cardInfo.iccid
            }
            getAllowChangePkgGroup(data).then(res => {
                if(res.data.code == 200){
                    this.allowPkgGroup = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }                
            })
        },        
        sureChangePkgGroupHandler(){
            var data = {
                basePkgGroup: this.pkgGroupForm.newPkgGroup,
                iccid: this.cardInfo.iccid,
                remark: this.pkgGroupForm.remark
            }
            toChangePkgGroup(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success('变更套餐成功！');
                    this.changePkgGroupVisible = false; 
                    this.getSimDetailInfoHandler(this.cardInfo.iccid)
                }else{
                    this.$message.error(res.data.message);
                }                
            })            
        },        
        showToNewCardHandler(){
            this.toNewCardVisible = true;
        },
        sureToNewCardHandler(){
            this.$refs.toNewCardForm.validate(valid => {
                if(valid){
                    var data = {
                        oldIccid: this.cardInfo.iccid,
                        newIccid: this.toNewCardForm.iccid,
                        moveType: this.toNewCardForm.moveType,
                        remark: this.toNewCardForm.remark
                    }
                    toNewCard(data).then(res => {
                        if(res.data.code == 200){
                            this.toNewCardVisible = false;
                            this.$message.success('转卡成功！');
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        simDiagnosisHandler(){
            this.$confirm("您确定使用一键诊断功能吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                simDiagnosis(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("诊断完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);  
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        stateRecordListHandler(){
            this.stateRecordVisible = true;
            var data = {
                perPageNum: this.pageSize_record,
                pageNo: this.currentPage_record,
                iccid: this.cardInfo.iccid          
            }            
            getSimStopStartRecordList(data).then(res => {
                if(res.data.code == 200){
                    var result = res.data.data;
                    this.tableData_record = result.resultList;
                    this.total_record = result.totalNum;
                    this.currentPage_record = result.pageNo;
                    this.pageSize_record = result.perPageNum;                       
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getFluxDetailListHandler(){
            this.fluxVisible = true;
            var data = {
                perPageNum: this.pageSize_flux,
                pageNo: this.currentPage_flux,
                simId: this.cardInfo.id          
            }
            getFluxDetailList(data).then( res => {
                if(res.data.code == 200){
                    var result = res.data.data;
                    this.tableData_flux = result.resultList;
                    this.total_flux = result.totalNum;
                    this.currentPage_flux = result.pageNo;
                    this.pageSize_flux = result.perPageNum;                       
                }else{
                    this.$message.error(res.data.message);
                }                
            })
        },
        showChangeCardStateHandler(){
            common.sysRequest('sim/state/dict', {}, 'get').then(res => {
                if(res.data.code == 200){
                    this.cardStateOption = res.data.data;
                    this.changeStateVisible = true;
                }else{
                    this.$message.error(res.data.message);
                }
            })
            
        },
        sureChangeStateHandler(){
            this.$refs.changeStateForm.validate(valid => {
                if(valid) {
           
                    var data = this.changeStateForm;
                    data.id = this.cardInfo.id;
                    changeCardState(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                            this.changeStateVisible = false;
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },     
        //跳转至【流量轮询详情】页面
        toFluxPollDetail(iccid){
            this.$store.commit('menu/setFluxPollDetailIccid', iccid);
            this.$store.commit('menu/setFluxPollDetailTaskNo', "");
            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '流量轮询详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/fluxPollDetail"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        handleSizeChange(val){
            this.pageSize = val;
            this.getOneSIMOrderListHandler();
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.getOneSIMOrderListHandler();
        },
        handleSizeChangeRecord(val){
            this.pageSize_record = val;
            this.stateRecordListHandler();
        },
        handleCurrentChangeRecord(val){
            this.currentPage_record = val;
            this.stateRecordListHandler();
        }, 
        handleSizeChangeFlux(val){
            this.pageSize_flux = val;
            this.getFluxDetailListHandler();
        },
        handleCurrentChangeFlux(val){
            this.currentPage_flux = val;
            this.getFluxDetailListHandler();
        },showOrderDetailHandler(row){//查看订单详情
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
            return ; 
        },modifyOrderInfoHandler(row){//修改订单备注 
            if(row.remark.length == ''){
                return ;
            }
            let param = {
                id:row.id,
                remark:row.remark
            }
            modifyOrderRemark(param).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    
                }else{
                    this.$message.error(res.data.message);
                }
            });

        },
        showAddOverlayPkg(){
            this.overlayPkgVisible = true;
            getOverlayPkgOptions({}).then(res => {
                if(res.data.code == 200){
                    this.overlayPkgGroup = res.data.data;
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        changeHandler(){
            this.overlayPkgForm.packageId = '';
            var data = {
                typeGroupId: this.overlayPkgForm.typeGroupId
            }
            common.getPkgOfGroupCom(this, 'overlayPkgList', data);
        },
        IllusoryCardState(row){
            if(row.cardState >= 5 && row.cardState!=11){//异常或违禁
                if(row.cardState == 12){
                  return '注销'
                }else if(row.cardState == 9){
                  return '故障'
                }
                return '正常';
            }else{
                return row.cardStateName;
            }
        },
        sureAddOverlayPkg(){
            this.$refs.overlayPkgForm.validate(valid => {
                if(valid){
                    var data = this.overlayPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.overlayPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })                    
                }
            })            
        },

        isExpiredTime(str){
            let d = new Date(str);
            if(d<new Date()){
                return true;
            } 
            return false;
        },
        showAddRealNameSearch(){//点击电信实名查询
            let data = {
                iccid: this.cardDetailsForm.iccid
            }
            getRealName(data).then(res => {
                if(res.data.code == 200){
                    this.$alert(res.data.data.msg, {
                    confirmButtonText: '确定'})
                }else{
                    this.$alert(res.data.message, {
                    confirmButtonText: '确定'})
                }
            })
        },
        //重置流量
        resetFlow(){
            this.$confirm('此功能仅供用户流量套餐异常时操作，不支持跨月套餐，仅支持小象卡，确定要重置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let param = {
                    id: this.cardInfo.id,
                    iccid: this.cardInfo.iccid
                }

                common.sysRequest('pkg/update/pkg', param, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => {});
        },//解绑
        resetFlow1(){
            this.$confirm('此功能一个月只能用两次，确定要解绑吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let param = {
                    id: this.cardInfo.id,
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('external/ctcc/bind', param, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => {});
        },
    },
    
    created(){
        
    },
    mounted () {
        let fromPage = this.$store.state.menu.fromPage;
        let fromPageIccid = this.$store.state.menu.fromPageIccid;
        if(fromPage == 'cardMgt' || fromPage == 'orderMgt'){
            this.cardDetailsForm.iccid = fromPageIccid;
            this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }
    },

    computed:{
        getSum: function(){
            let sum = 0;
            for(let i=0; i<this.cardInfo.simPackageList.length; i++){
                sum += Number(this.fluxMtoG(this.cardInfo.simPackageList[i].usedRealFlowRate));
            }
            return this.money_format(sum, 2);
        }
    },
}
</script>

<style lang="less">
#cardDetails {
    font-size: 12px;

    .section1, .section2,.section3,.section4,.section5 {
        margin-bottom: 30px;  
        padding-left: 8px;
    }
    .section2 {
        .el-row {
            line-height: 40px;
        }
    }
    .section3 {
        .el-row {
            line-height: 34px;
            margin-bottom: 20px;
        }
        
        .progressOuter {
            line-height: normal;
            .el-progress {
                margin: 5px 0;
            }
        }

        .pOuter{
            margin-top: -10px;
        }
    }
    .section4 {
        div {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .el-button {
                flex: 1;
                margin-bottom: 10px;            
            }
        }
    }
    h4 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;
    }

    /*新增套餐*/
    .pkgName {
        display: block;
        label.el-radio {
            width: 50%;
            margin: 10px 0 15px 0;
        }
    }

    .span-defined{
        margin-right: 20px;
    }

    .font-defined{
        font-size:24px;
    }

    .green{
        color:#309200;
    }

    .red{
        color:#c71c1c;
    }

    .dark{
        color:#7d7d5d;
    }

    .text-animation-default{
        animation:text-animation 3s infinite ease-out;
    }
    
    @keyframes text-animation {
        0% {
            transform:  translateY(-30px);
        }
        1.5% {
            transform:  translateY(30px);
        }
        3% {
            transform:  translateY(-30px);
        }
        4.5% {
            transform:  translateY(30px);
        }
        6% {
            transform:  translateY(-30px);
        }
        7.5% {
            transform:  translateY(30px);
        }
        9% {
            transform:  translateY(-30px);
        }
        10.5%{
            transform:  translateY(30px);
        }
        12%{
            transform:  translateY(-30px);
        }
        13.5%{
            transform:  translateY(30px);
        }
        15%{
            transform:  translateY(-30px);
        }

        50% {
            transform:  scale(1.6) translateY(30px);
        }

        100% {
            transform:  scale(1.6) translateY(30px);
        }
    }
}
</style>

